namespace aq.ui {

    export class AqSidebarNavNestedMenuItem implements common.models.SidebarNavItem {
        public title: string;
        public state: string;
        public stateData: any;
        public stateOptions: any;
        public icon: string;
        public aria: string;
        public isActiveFn: () => boolean;
        public actionFn: () => boolean;

        /* @ngInject */
        constructor(private SidebarNavHelperService: aq.services.SidebarNavHelperService, private $mdMedia: angular.material.IMedia) {
            this.title = '';
            this.state = '';
            this.stateData = null;
            this.stateOptions = null;
            this.icon = '';
            this.aria = '';
        }

        private getIconLetter() {
            return (this.title && this.title.length > 0) ? this.title.substring(0, 1) : '';
        }
    }

    angular
        .module('aq.ui')
        .component('aqSidebarNavNestedMenuItem', {
            templateUrl: 'app/common/directives/aqSidebarNav/aqSidebarNavNestedMenu/aqSidebarNavNestedMenuItem/aqSidebarNavNestedMenuItem.html',
            controller: AqSidebarNavNestedMenuItem,
            controllerAs: 'vm',
            bindings: {
                title: '@',
                state: '@?',
                stateData: '<?',
                stateOptions: '<?',
                icon: '@?',
                aria: '@?',
                isActiveFn: '&?',
                actionFn: '&?'
            },
            require: {
                parent: '^^aqSidebarNavNestedMenu'
            }
        });
}
